'use client';

import { c as _c } from "react/compiler-runtime";
import { trackFilterChanged } from '@/lib/analytics/client/trackers/filter';
import type { DateRangeValue } from './dateRange';
import { DateRangePicker, type DateRangePickerProps } from './DateRangePicker';
export interface DateRangeFilterProps extends Omit<DateRangePickerProps, 'onChange'> {
  onChange: (value: DateRangeValue | undefined) => void;
  /** Analytics page identifier — omit to skip tracking. */
  page?: string;
}

/**
 * App wrapper around {@link DateRangePicker} that reports usage to PostHog,
 * keeping the presentational picker free of analytics so it stays portable.
 */
export const DateRangeFilter = t0 => {
  const $ = _c(12);
  let onChange;
  let page;
  let pickerProps;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      page,
      ...pickerProps
    } = t0);
    $[0] = t0;
    $[1] = onChange;
    $[2] = page;
    $[3] = pickerProps;
    $[4] = value;
  } else {
    onChange = $[1];
    page = $[2];
    pickerProps = $[3];
    value = $[4];
  }
  let t1;
  if ($[5] !== onChange || $[6] !== page) {
    t1 = (next, source) => {
      onChange(next);
      if (page) {
        trackFilterChanged({
          filterName: "date_range",
          filterValue: next ? source : null,
          page
        });
      }
    };
    $[5] = onChange;
    $[6] = page;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== pickerProps || $[9] !== t1 || $[10] !== value) {
    t2 = <DateRangePicker value={value} onChange={t1} {...pickerProps} />;
    $[8] = pickerProps;
    $[9] = t1;
    $[10] = value;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};